<template>
  <v-card id="create">
    <v-speed-dial
      v-model="fab"
      :top="top"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <!-- اضافه شدن کلاس prominent-fab و elevation -->
        <v-btn 
          v-model="fab" 
          :color="color" 
          dark 
          fab 
          elevation="8" 
          class="prominent-fab"
        >
          <v-icon v-if="fab">mdi-close</v-icon> 
          <v-icon v-else>mdi-share-variant-outline</v-icon>
        </v-btn>
      </template>

      <!-- کلمه scroll به auto تغییر کرد و کلاس hide-scroll اضافه شد -->
      <div style="overflow-y: auto; max-height: 270px" class="py-2 custom-scroll">
        <!-- اضافه شدن elevation به دکمه‌های زیرمجموعه -->
        <v-btn
          @click="goToUrl(item.url, item.pattern)"
          :color="color"
          fab
          small
          elevation="4"
          class="mb-2"
          v-for="(item, i) in computeFields"
          :key="i"
        >          
          <img :src="item.img" alt="" class="img-fluid"             
            :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '27px' : '30px'"
            :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '27px' : '30px'"
          />
        </v-btn>
      </div>
    </v-speed-dial>
  </v-card>
</template>

<script>
export default {
  name: "floatingBtn",

  props: {
    value: {},
    color: { type: String, default: 'pink darken-2' } 
  },

  data: () => ({
    direction: "bottom",
    transition: "slide-y-transition",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    right: true,
    bottom: false,
    left: false,
    top: true,
  }),

  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value).forEach(([x, y]) => {
        extra.push(...y);
      });

      return extra;
    },
  },

  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },

  methods: {
    isBigSvg(svg) {
    const list = [
      'svgdigikala',
      'svgbasalam',
      'svgsnappshop',
      'svgtechnolife',
      'svgtorob',
      'svgemalls',
      'svgrubika',
      'svgwhatsapp',
      'svgbale',
      'svgeitaa',
      'svgsoroush',
      'svgtelegram',
      'svgviber',
      'svgwechat',
      'svgsheypour',
      'svgdivar',
      'svgaparat',
      'svggap'
    ];
    return list.includes((svg || '').toLowerCase());
  },

    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
  },
};
</script>

<style scoped>
#create .v-speed-dial {
  position: absolute;
  z-index: 10;
  top: 10px; 
  right: 10px; 
}

#create .v-btn--floating {
  position: relative;
}

/* استایل‌های دکمه برجسته */
.prominent-fab {
  width: 55px !important;
  height: 55px !important;
  /* ایجاد سایه نرم و سه‌بعدی */
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.25) !important;
  transition: all 0.3s ease !important;
  border: 2px solid rgba(255, 255, 255, 0.15); /* حاشیه شیشه‌ای و ظریف */
}

/* افکت هنگام رفتن موس روی دکمه */
.prominent-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.3) !important;
}

/* برای دکمه در حالت باز شده (آیکون ضربدر) */
.prominent-fab.v-btn--active {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
  transform: scale(0.95);
}

/* --- استایل‌های مخفی کردن اسکرول‌بار --- */

/* برای مرورگرهای مبتنی بر Webkit (کروم، سافاری، اج جدید) */
.hide-scroll::-webkit-scrollbar {
  display: none;
}

/* برای فایرفاکس و اینترنت اکسپلورر */
.hide-scroll {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
#create {
  position: absolute;
  z-index: 9999 !important;
  top: 10px;
  right: 10px;
  overflow: visible !important;
  background: transparent !important;
  box-shadow: none !important;
}

#create .v-speed-dial {
  z-index: 9999 !important;
}

#create .v-btn--floating {
  position: relative;
}

/* افکت شیشه‌ای مات و تابش نور برای دکمه اصلی */
.prominent-fab {
  width: 55px !important;
  height: 55px !important;
  backdrop-filter: blur(10px) !important; /* افکت شیشه‌ای مات */
  border: 1px solid rgba(255, 255, 255, 0.6) !important; /* لبه براق شیشه‌ای */
  box-shadow: 
    0 10px 25px -5px rgba(0, 0, 0, 0.5), /* سایه عمق‌دار بیرونی */
    inset 0 6px 15px rgba(255, 255, 255, 0.6), /* نور تابیده شده به داخل */
    0 0 15px rgba(255, 255, 255, 0.2) !important; /* هاله نور بیرونی */
  transition: all 0.3s ease !important;
}

.prominent-fab:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 14px 28px rgba(0, 0, 0, 0.6),
    inset 0 8px 18px rgba(255, 255, 255, 0.8), /* نور داخلی در هاور شدیدتر می‌شود */
    0 0 25px rgba(255, 255, 255, 0.4) !important;
}

.prominent-fab.v-btn--active {
  transform: scale(0.95);
  box-shadow: 
    0 5px 15px rgba(0, 0, 0, 0.4),
    inset 0 3px 8px rgba(255, 255, 255, 0.4) !important;
}

/* استایل‌دهی به اسکرول‌بار به جای مخفی کردن آن */
.custom-scroll::-webkit-scrollbar {
  width: 4px; /* اسکرول‌بار باریک و ظریف */
}

.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4); /* رنگ نیمه شفاف برای اسکرول */
  border-radius: 10px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.8); /* پررنگ شدن با هاور */
}
</style>
